/**
 * Async scrollTo
 * Scrolls to an offset, then resolves after window scrolls to that offset.
 *
 * @param offset Offset to scroll to (default 0)
 * @param behaviour Scrolling behaviour (default 'smooth')
 * @returns {Promise<Boolean>}
 */
export function asyncScrollTo(offset = 0, behaviour = 'smooth') {
    return new Promise((resolve, reject) => {
        if (typeof window === 'undefined') {
            resolve(true);
            return;
        }

        const targetOffset = offset.toFixed();
        const onScroll = () => {
            if (window.pageYOffset.toFixed() === targetOffset) {
                window.removeEventListener('scroll', onScroll);
                resolve(true);
            }
        };

        window.addEventListener('scroll', onScroll);
        onScroll();

        scrollTo(offset, behaviour);
    });
}

/**
 * scrollTo
 * Scrolls to an offset.
 *
 * @param offset Offset to scroll to (default 0)
 * @param behaviour Scrolling behaviour (default 'smooth')
 */
export function scrollTo(offset = 0, behaviour = 'smooth') {
    typeof window !== 'undefined' && window.scrollTo({
        top: offset,
        behavior: behaviour
    });
}

/**
 *
 * scrollToRef
 * Scrolls to a given ref.
 *
 * @param ref A reference created with createRef, etc
 * @param behaviour Scrolling behaviour (default 'smooth')
 * @returns {boolean} True is the ref is visible, false otherwise.
 */
export function scrollToRef(ref, behaviour = 'smooth') {
    if (ref.current) {
        ref.current.scrollIntoView({ behavior: behaviour });
        return true;
    }

    return false;
}

export const scrollToTop = (offsetTop = 0, offset = 0) => {
    window.scrollTo({
        top: offsetTop + offset,
        left: 0,
        behavior: 'smooth',
    });
};
